<template>
    <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
      <zj-layout-header>
        <div class="listtitle">救援队伍</div>
        <el-form class="zj-search-form clear" ref="form" :model="form">
          <el-form-item label="擅长事故类型">
            <el-select v-model="goodAccidentsType" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.code"
                :label="item.value"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="队伍类型">
            <el-select v-model="teamType" placeholder="请选择">
              <el-option
                v-for="item in options2"
                :key="item.code"
                :label="item.value"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="负责人" prop="responsiblePerson">
            <el-input v-model="responsiblePerson"></el-input>
          </el-form-item>
          <el-form-item label="救援队伍名称" prop="teamName">
            <el-input v-model="teamName"></el-input>
          </el-form-item>
          <el-form-item label="" class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main style="padding-top:0px;">
        <zj-layout-container>
          <zj-layout-header>
            <div class="zj-button-bar">
              <el-button size="mini" @click="onAdd">添 加</el-button>
              <el-button size="mini" @click="onbatchDel">删 除</el-button>
            </div>
          </zj-layout-header>
          <zj-layout-main style="padding:0.8rem 0px 0px 0px;">
            <el-table
              :data="tableData"
              ref="multipleTable"
              @selection-change="selectionChange"
              border
              style="width: 100%"
              height="100%"
            >
              <el-table-column type="selection" width="40" align="center"></el-table-column>
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="teamName" label="队伍名称"></el-table-column>
              <el-table-column prop="teamTypeTranslated" label="队伍类型" align="center"></el-table-column>
              <el-table-column prop="goodAccidentsTypeTranslated" label="擅长事故类型" align="center"></el-table-column>
              <el-table-column prop="totalNum" label="总人数" align="center"></el-table-column>
              <el-table-column prop="responsiblePerson" label="负责人" align="center"></el-table-column>
              <el-table-column prop="mobileNo" label="负责人电话" align="center"></el-table-column>
              <el-table-column prop="modifydate" label="修改时间" width="180" align="center"></el-table-column>
              <el-table-column label="操作" width="130" align="center">
                <template slot-scope="scope">
                  <el-button @click="handleClick(scope.$index,scope.row)" type="text" size="small">查看</el-button>
                  <el-button @click="editClick(scope.$index,scope.row)" type="text" size="small">编辑</el-button>
                  <el-button @click="deleteClick(scope.$index,scope.row)" type="text" size="small">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </zj-layout-main>
        </zj-layout-container>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
</template>

<script>
import ZJApp from '../../../../../app';
const utils = ZJApp.ZJUtils;

import { getDictionary } from "@/api/src/emergency_common";
import { list, remove } from "@/api/src/emergency_resourcesTeam";
export default {
  name: "ZjResourcesTeamlist",
  controller: "EmergencyResource",
  action: "ResourcesTeamlist",
  data() {
    return {
      loading: false,
      loadingText: '加载中...',
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      goodAccidentsType: null,
      options: [],
      teamType: null,
      options2: [],
      responsiblePerson: null,
      teamName: null,
      selectData: null,
      goodAccidentsTypeDic:[],
      teamTypeDic:[]
    };
  },
  created: function() {
    this.basedatabind().then(()=>{
      this.search();
    });
  },
  methods: {
    // 表格的选中 可以获得当前选中的数据
    selectionChange(val) {
      // 将选中的数据存储起来
      this.selectData = val;
    },
    search() {
      let searchInfo = {
        teamName: this.teamName,
        responsiblePerson: this.responsiblePerson,
        teamType: this.teamType,
        goodAccidentsType: this.goodAccidentsType,
        size: this.pageSize,
        current: this.currentPage,
      };
      this.loading = true;
      this.loadingText = '加载中...';
      list(searchInfo)
        .then(r => {
          r = r.data;
          this.tableData = r.records;
          this.total = r.total;
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.loading = false;
        });
    },
    clearsearch() {
      this.goodAccidentsType = null;
      this.teamType = null;
      this.responsiblePerson = null;
      this.teamName = null;
    },
    //基础数据绑定
    basedatabind() {
      this.loading = true;
      this.loadingText = '加载中...';
      return utils.waitAll([
        getDictionary('emergency_team_good_accidents'),
        getDictionary('emergency_team_type'),
      ])
      .then(r => {

        //擅长事故类型
        this.options = r[0].data.records;

        //队伍类型
        this.options2 = r[1].data.records;

        this.loading = false;

        return r;
      })
      .catch(e => {
        console.error(e);
        this.loading = false;
      });

    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    //编辑按钮
    editClick(index, { id, teamBelong }) {
      this.$router.push({
        path: "/plugin/emergency/EmergencyResource/ResourcesTeamManage",
        query: {
          id,
          teamBelong,
          type: "edit"
        }
      });
    },
    //查看详细
    handleClick(index, { id, teamBelong }) {
      this.$router.push({
        path: "/plugin/emergency/EmergencyResource/ResourcesTeamManage",
        query: {
          id,
          teamBelong,
          type: "search"
        }
      });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/emergency/EmergencyResource/ResourcesTeamManage",
        query: {
          id: null,
          teamBelong:null,
          type: "edit",
          oper:"add"
        }
      });
    },
    //批量删除
    onbatchDel() {
      if (
        this.selectData != undefined &&
        this.selectData != null &&
        this.selectData.length > 0
      ) {
        this.$confirm("选中的数据将被永久删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            const selectData = this.selectData;
            const count = selectData.length;
            // 清除 所有勾选项
            this.$refs.multipleTable.clearSelection();
            if (count > 0) {
              let ids = selectData.map(item =>item.id)
              this.delete(ids.join(','))
            }
          });
      } else {
        this.$message({
          type: "info",
          message: "未选中任何行！"
        });
      }
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.delete(row.id)
        });
    },
    delete(idList){
      this.loading = true;
      this.loadingText = '删除中...';
      remove({idList}).then(r => {
        r = r.data;
        if (r) {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        } else {
          this.$message({
            type: "error",
            message: "删除失败!"
          });
        }
        this.loading = false;
        this.search();
      })
      .catch(e => {
        this.loading = false;
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
  }
};
</script>